import type { StockTransferDetail } from "@/modules/inventory/presentation/api/client";

const QTY_EPS = 1e-6;

export function normalizeTransferQty(
  value: number | string | null | undefined,
  fallback: number,
): number {
  if (value == null || value === "") return Number(fallback);
  const n = typeof value === "number" ? value : Number(value);
  return Number.isFinite(n) ? n : Number(fallback);
}

export function transferQtyEqual(a: number, b: number): boolean {
  return Math.abs(a - b) < QTY_EPS;
}

/** Hub ຄົງເຫຼືອພໍສຳລັບຈຳນວນອະນຸມັດຫຼືບໍ່ */
export function hubQtyInsufficient(
  qtyApproved: number,
  qtyAvailable: number | undefined,
): boolean {
  if (typeof qtyAvailable !== "number" || !Number.isFinite(qtyAvailable)) {
    return false;
  }
  return qtyApproved > qtyAvailable + QTY_EPS;
}

export function qtyApprovedMapFromTransfer(
  transfer: StockTransferDetail,
): Record<string, number> {
  const next: Record<string, number> = {};
  for (const line of transfer.lines) {
    next[line.id] = normalizeTransferQty(
      line.qtyApproved,
      line.qtyRequested,
    );
  }
  return next;
}
